import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

//app
import App from './pages/app';
import './styles/root.css';
import { Provider } from 'react-redux';
import { store } from './app/store';
import history from './common/history';
import { Router } from 'react-router-dom';
import { SetApiClientStore } from './api/httpClient';
import { registerLicense } from '@syncfusion/ej2-base';

// Allow httpclient to access redux store.
SetApiClientStore(store);
registerLicense("ORg4AjUWIQA/Gnt2VVhhQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkFiXX5ddXJVT2VaVEM=");
const isTesting = process.env.REACT_APP_IS_TESTING ?? false;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <div style={{ display: 'inline', width: '100vw'/*, height: "100vh"*/ }}>
          {isTesting && (
            <div style={{ backgroundColor: 'red', color: '#eee', textAlign: 'center', padding: '5px', fontWeight: 'bolder', fontSize: '20px', height: '5vh' }}>
              <span style={{ padding: '15px' }}>THIS IS A TEST SITE</span>
              <span style={{ padding: '15px' }}>THIS IS A TEST SITE</span>
              <span style={{ padding: '15px' }}>THIS IS A TEST SITE</span>
              <span style={{ padding: '15px' }}>THIS IS A TEST SITE</span>
              <span style={{ padding: '15px' }}>THIS IS A TEST SITE</span>
            </div>
          )}
          <App />
        </div>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
